/*
An accessible menu for WordPress

https://github.com/theme-smith/accessible-nav-wp
Kirsten Smith (kirsten@themesmith.co.uk)
Licensed GPL v.2 (http://www.gnu.org/licenses/gpl-2.0.html)

This work derived from:
https://github.com/WordPress/twentysixteen (GPL v.2)
https://github.com/wpaccessibility/a11ythemepatterns/tree/master/menu-keyboard-arrow-nav (GPL v.2)
*/

jQuery(window).on('load', function() {

	const menuContainer  = $('.page-header');
	const menuToggle     = menuContainer.find('.menu-button');
	const siteHeaderMenu = menuContainer.find('#site-header-menu');
	const siteNavigation = menuContainer.find('#site-navigation');

	// If you are using WordPress, and do not need to localise your script, or if you are not using WordPress, then uncomment the next line
	const screenReaderText = {
		"expand": "Expand child menu",
		"collapse": "Collapse child menu"
	};

	const dropdownToggle = $('<button />', {
			'class': 'dropdown-toggle',
			'aria-expanded': false
		})
		.append($('<span />', {
			'class': 'screen-readers',
			text: screenReaderText.expand
		}));


	// Toggles the menu button
	(function () {

		if (!menuToggle.length) {
			return;
		}

		menuToggle.add(siteNavigation).attr('aria-expanded', 'false');

		menuToggle.on('click', function () {
			$(this).add(siteHeaderMenu).toggleClass('toggled-on');

			// jscs:disable
			$(this).add(siteNavigation)
				.attr('aria-expanded', $(this)
					.add(siteNavigation).attr('aria-expanded') === 'false' ? 'true' : 'false');
			// jscs:enable

		});
	})();

	// Adds the dropdown toggle button
	$('.menu-item-has-children > a').after(dropdownToggle);

	// Adds aria attribute
	siteHeaderMenu.find('.menu-item-has-children').attr('aria-haspopup', 'true');

	// Toggles the sub-menu when dropdown toggle button clicked
	siteHeaderMenu.find('.dropdown-toggle').click(function (e) {

		let screenReaderSpan = $(this).find('.screen-readers');

		e.preventDefault();
		$(this).toggleClass('toggled-on');
		$(this).nextAll('.sub-menu').toggleClass('toggled-on');

		// jscs:disable
		$(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'false' ?
			'true' : 'false');
		// jscs:enable
		screenReaderSpan.text(screenReaderSpan.text() ===
			screenReaderText.expand ? screenReaderText.collapse :
			screenReaderText.expand);
	});

	// Adds a class to sub-menus for styling
	$('.sub-menu .menu-item-has-children').parent('.sub-menu').addClass('has-sub-menu');


});
